import { Descendant, Editor, Transforms } from 'slate';
import { isEjs, isSelectionEjs } from '../helpers';
import { EjsButtonElement, EjsPlaceholderElement } from '../types';

export const insertEjs = (
	editor: Editor,
	element: EjsButtonElement | EjsPlaceholderElement
) => {
	const elements: Descendant[] = [element];

	// Add paragraph after button (button is block element)
	if (element.type === 'ejs-button') {
		elements.push({
			type: 'paragraph',
			children: [{ text: '' }],
		});
	}

	Transforms.insertNodes(editor, elements);
};

export const removeEjsNode = (editor: Editor) => {
	const selection = editor.selection;

	if (!selection || !isSelectionEjs(editor)) return;

	// Delete entire block of ejs element
	Transforms.removeNodes(editor, {
		match: isEjs,
		at: selection.anchor,
	});
};
